import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { PageHero, Reveal } from "@/components/Primitives";
import { CITIES } from "@/data/site";

export default function ServiceAreas() {
  return (
    <>
      <Seo
        title="Service Areas"
        description="Mom's Best Friend Sitters serves families across the DFW metroplex — Dallas, Frisco, Southlake, Fort Worth, Plano and Colleyville with 11-step screened caregivers."
        breadcrumbs={[{ name: "Home", item: "/" }, { name: "Service Areas", item: "/service-areas" }]}
      />
      <PageHero
        overline="Where we serve"
        title="Trusted caregivers across DFW"
        subtitle="Three decades of local relationships across the Dallas–Fort Worth metroplex. Find your city below."
      />

      <section className="container-mbf py-20 md:py-28">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {CITIES.map((city, i) => (
            <Reveal key={city.id} delay={i * 0.05}>
              <Link to={`/service-areas/${city.id}`} className="card-warm overflow-hidden flex flex-col h-full group" data-testid={`servicearea-card-${city.id}`}>
                <div className="h-40 overflow-hidden">
                  <img src={city.image} alt={`${city.name}, TX`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <MapPin className="w-4 h-4 text-terracotta" />
                    <h2 className="font-serif text-xl text-espresso group-hover:text-terracotta transition-colors">{city.name}</h2>
                  </div>
                  <p className="text-sm text-stoneish leading-relaxed flex-1">{city.blurb}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-terracotta">
                    Care in {city.name} <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
